module.exports = __webpack_public_path__ + "static/media/petrosea.eed35859.png";